<app-view-item *ngIf="disabled" [text]="displayText" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!disabled" nz-input [(ngModel)]="value" (ngModelChange)="onModelChange($event)" nzAllowClear="false"
  [nzDisabled]="allowEdit === false" [nzDropdownMatchSelectWidth]="false">
  <ng-container *ngFor="let item of options">
    <nz-option [nzValue]="item.value" [nzLabel]="getLabel(item)" nzCustomContent>
      <div class="dropdown-container" *ngIf="showCode">
        <div class="width-lg max-width-xl">
          <strong>{{ item.value }}</strong>
          -
          <span> {{ item.label }}</span>
        </div>
      </div>
      <div class="dropdown-container" *ngIf="!showCode">
        <div class="width-lg max-width-xl">
          <span> {{ item.label }}</span>
        </div>
      </div>
    </nz-option>
  </ng-container>
</nz-select>
